window.addEventListener("DOMContentLoaded", () => {
    (() => {
        let visibleCardIndex = 0;
        const carousel = document.querySelector(".section-card-carousel div[data-carousel]");
        const carouselArrowLeft = document.querySelector(
            `.section-card-carousel button[data-carousel-direction="left"]`
        );
        const carouselCards = [...document.querySelectorAll(".section-card-carousel .card-carousel-card")];
        const carouselArrowRight = document.querySelector(
            `.section-card-carousel button[data-carousel-direction="right"]`
        );

        carouselArrowLeft.addEventListener("click", () => {
            if (visibleCardIndex > 0) {
                carousel.scrollLeft = carouselCards[visibleCardIndex - 1]?.offsetLeft;
                visibleCardIndex--;
            }
        });
        carouselArrowRight.addEventListener("click", () => {
            if (visibleCardIndex < carouselCards.length - 1) {
                carousel.scrollLeft = carouselCards[visibleCardIndex + 1]?.offsetLeft;
                visibleCardIndex++;
            }
        });
    })();
});
